<div class="gift-form-container">
  <form nz-form [formGroup]="form" [nzLayout]="'vertical'">

    <div class="form-section">
      <!-- <div class="section-header">
        <h3 class="section-title">Gift Requirements</h3>
      </div> -->

      <nz-form-item>
        <nz-form-label nzRequired>Gifts & Merchandise Details</nz-form-label>
        <nz-form-control>
          <textarea nz-input formControlName="gift_details" rows="4" placeholder="Enter gifts & merchandise details">
          </textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Budget (USD)</nz-form-label>
        <nz-form-control>
          <input nz-input type="number" formControlName="gift_rate" placeholder="Enter budget" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control>
          <button nz-button nzType="primary" (click)="onSave()" [disabled]="form.invalid">
            Submit
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>

  </form>
</div>